import React from 'react';

export const STATE_TILES = {
  AK: [0, 0], ME: [11, 0],
  VT: [10, 1], NH: [11, 1],
  WA: [1, 2], ID: [2, 2], MT: [3, 2], ND: [4, 2], MN: [5, 2], IL: [6, 2], WI: [7, 2], MI: [8, 2], NY: [9, 2], RI: [10, 2], MA: [11, 2],
  OR: [1, 3], NV: [2, 3], WY: [3, 3], SD: [4, 3], IA: [5, 3], IN: [6, 3], OH: [7, 3], PA: [8, 3], NJ: [9, 3], CT: [10, 3],
  CA: [1, 4], UT: [2, 4], CO: [3, 4], NE: [4, 4], MO: [5, 4], KY: [6, 4], WV: [7, 4], VA: [8, 4], MD: [9, 4], DE: [10, 4],
  AZ: [2, 5], NM: [3, 5], KS: [4, 5], AR: [5, 5], TN: [6, 5], NC: [7, 5], SC: [8, 5], DC: [9, 5],
  OK: [4, 6], LA: [5, 6], MS: [6, 6], AL: [7, 6], GA: [8, 6],
  HI: [0, 7], TX: [4, 7], FL: [9, 7],
};

const TILE_RGB = '25, 130, 196';
const formatCount = (n) => Number(n || 0).toLocaleString();

export function shade(count, maxCount) {
  if (!count || !maxCount) return 0;
  return Math.log1p(count) / Math.log1p(maxCount);
}

function StateTileMap({ states, total, countHeader = 'Fans' }) {
  const counts = Object.fromEntries(states.filter((s) => STATE_TILES[s.label]).map((s) => [s.label, s.count]));
  const maxCount = Math.max(0, ...Object.values(counts));
  const usTotal = Object.values(counts).reduce((sum, n) => sum + n, 0);
  const otherTotal = total - usTotal;
  const topStates = states.filter((s) => STATE_TILES[s.label]).slice(0, 3);
  const pct = (n) => (total ? `${((n * 100) / total).toFixed(1)}%` : '0%');

  return (
    <div className="p-3">
      <div
        role="img"
        aria-label={`${countHeader} by state: ${topStates.map((s) => `${s.label} ${formatCount(s.count)}`).join(', ')}`}
        style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 3 }}
      >
        {Object.entries(STATE_TILES).map(([code, [col, row]]) => {
          const count = counts[code] || 0;
          const intensity = shade(count, maxCount);
          const strong = intensity > 0.55;
          return (
            <div
              key={code}
              title={`${code}: ${formatCount(count)} ${countHeader.toLowerCase()} (${pct(count)})`}
              style={{
                gridColumn: col + 1,
                gridRow: row + 1,
                aspectRatio: '1',
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 11,
                fontWeight: 600,
                background: count ? `rgba(${TILE_RGB}, ${0.12 + 0.88 * intensity})` : 'var(--sl-bg-tertiary, #f5f5f5)',
                color: strong ? 'var(--sl-text-white, #ffffff)' : 'var(--sl-text-secondary, #414651)',
              }}
            >
              {code}
            </div>
          );
        })}
      </div>

      <div className="d-flex align-items-center mt-3" style={{ gap: 8, fontSize: 12, color: 'var(--sl-text-tertiary, #535862)' }}>
        <span>Fewer</span>
        <div style={{ width: 96, height: 8, borderRadius: 4, background: `linear-gradient(to right, rgba(${TILE_RGB}, 0.12), rgba(${TILE_RGB}, 1))` }} />
        <span>More</span>
      </div>

      <div className="mt-2" style={{ fontSize: 13, color: 'var(--sl-text-secondary, #414651)' }}>
        {topStates.map((s) => `${s.label} ${formatCount(s.count)} (${pct(s.count)})`).join(' · ')}
      </div>
      {otherTotal > 0 && (
        <div className="mt-1" style={{ fontSize: 12, color: 'var(--sl-text-tertiary, #535862)' }}>
          {formatCount(otherTotal)} {countHeader.toLowerCase()} outside the US or with no state on file
        </div>
      )}
    </div>
  );
}

export default StateTileMap;
